import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 120px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ContainerWithoutPading = styled.div`
  border-radius: 4px;
  padding: 60px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const EmptyImg = styled.img`
  width: 135px;
`;
export const Description = styled.p`
  font-size: 18px;
  line-height: 28px;
  max-width: 435px;
  margin: 0 auto;
  margin-top: 50px;
  text-align: center;
  span {
    font-weight: 900;
  }
`;

export const DescriptionSmallText = styled.p`
  font-size: 16px;
  line-height: 28px;
  max-width: 435px;
  margin: 0 auto;
  margin-top: 50px;
  text-align: center;
  span {
    font-weight: 900;
  }
`;
